import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATH } from 'src/environments/environment';
import { ISlipResponse } from 'src/app/domain/registration/interfaces/slip.interface';
import { SlipCreateRequest } from 'src/app/domain/registration/models/slips/ISlipCreateRequest';
import { SlipFilters } from 'src/app/domain/registration/models/slips/ISlipFilters';
import { SlipResponse } from 'src/app/domain/registration/models/slips/ISlipResponse';

@Injectable({
    providedIn: 'root'
})
export class SlipService {
    private readonly baseUrl = `${API_PATH}slips`;

    constructor(private http: HttpClient) { }

    createDirectSlip(request: SlipCreateRequest): Observable<ISlipResponse> {
        return this.http.post<ISlipResponse>(`${this.baseUrl}/direct`, request, {
            headers: { 'X-Skip-Loading': 'true' }
        });
    }

    createSlipWithBill(request: SlipCreateRequest): Observable<ISlipResponse> {
        return this.http.post<ISlipResponse>(`${this.baseUrl}`, request, {
        });
    }

    generateSlipsWithBillAndWithoutLoad(request: SlipCreateRequest): Observable<ISlipResponse> {
        return this.http.post<ISlipResponse>(`${this.baseUrl}`, request, {
            headers: { 'X-Skip-Loading': 'true' }
        });
    }

    getSlip(id: string, refresh?: boolean): Observable<ISlipResponse> {
        const params: any = {};
        if (refresh) {
            params.refresh = 'true';
        }
        return this.http.get<ISlipResponse>(`${this.baseUrl}/${id}`, { params });
    }

    listSlips(filters: SlipFilters): Observable<{ data: ISlipResponse[]; total: number }> {
        return this.http.get<{ data: ISlipResponse[]; total: number }>(`${this.baseUrl}`, { params: filters as any });
    }

    listSlipsPaginated(filters: SlipFilters): Observable<{ data: ISlipResponse[]; total: number }> {
        return this.http.get<{ data: ISlipResponse[]; total: number }>(`${this.baseUrl}/paginated`, { params: filters as any });
    }

    cancelSlip(id: string): Observable<ISlipResponse> {
        return this.http.post<ISlipResponse>(`${this.baseUrl}/${id}/cancel`, {});
    }

    syncSlip(id: string): Observable<ISlipResponse> {
        return this.http.post<ISlipResponse>(`${this.baseUrl}/${id}/sync`, {});
    }

    getSlipPdf(id: string): Observable<Blob> {
        return this.http.get(`${this.baseUrl}/${id}/pdf`, { responseType: 'blob' });
    }
    getSlipByInstallment(installmentId: string): Observable<any> {
        return this.listSlips({ billItemId: installmentId });
    }

    createSlip(request: SlipCreateRequest, linkedBill: boolean,skipLoad?:boolean): Observable<ISlipResponse> {
        if (linkedBill && !skipLoad) {
            return this.createSlipWithBill(request)
        }
        if(linkedBill && skipLoad){
            return this.generateSlipsWithBillAndWithoutLoad(request);
        } 

        return this.createDirectSlip(request);
    }

}